import { useParams } from "react-router-dom";
import { Spinner } from "@heroui/react";
import {
  useProblematicCampaignsQuery,
  CampaignCard,
  type Campaign,
} from "@/entities/campaign";
import { ProblematicCampaignsHeader } from "./ProblematicCampaignsHeader";
import { ProblematicEmptyState } from "./ProblematicEmptyState";

export const ProblematicCampaignsPage = () => {
  const { client: clientParam } = useParams<{ client?: string }>();
  const {
    data: response,
    isLoading,
    error,
  } = useProblematicCampaignsQuery(clientParam);

  const campaigns: Campaign[] = response?.data || [];

  return (
    <div className="flex flex-col gap-6">
      {/* Унифицированный заголовок страницы */}
      <ProblematicCampaignsHeader
        clientLogin={clientParam}
        count={campaigns.length}
      />

      {/* Индикатор загрузки */}
      {isLoading && (
        <div className="py-20 flex flex-col items-center justify-center gap-3">
          <Spinner size="lg" />
          <p className="text-xs text-neutral-400">
            Поиск и анализ кампаний на наличие проблем...
          </p>
        </div>
      )}

      {/* Ошибка запроса */}
      {!isLoading && error && (
        <div className="p-6 rounded-2xl border border-rose-500/30 bg-rose-500/10 text-rose-400 text-xs">
          Не удалось загрузить список проблемных кампаний.
        </div>
      )}

      {/* Список проблемных карточек или пустое состояние */}
      {!isLoading && !error && (
        <div className="flex flex-col gap-3.5">
          {campaigns.map((campaign) => {
            const campaignId = campaign.campaign_id || campaign.id;
            return (
              <CampaignCard
                key={campaignId}
                campaign={campaign}
              />
            );
          })}

          {campaigns.length === 0 && <ProblematicEmptyState />}
        </div>
      )}
    </div>
  );
};
